

import { useEffect } from 'react'
import Select from 'react-select'
import { VendorNameDDLAPI, WardNameDDLAPI } from '../../Redux/DDLSlice'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { AstricSign } from '../../Helper/AstricSign'

export const VendorNameDDL = (props) => {
    const { 
        WardName,
        VendorName,
        setVendorName,
        APIFlag } = props

        console.log('WardName', WardName)
    const userDetails = useAuthState();
    const { UserID, RoleID, token, } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = {
            WardName : WardName?.ID,
            UserID : UserID,
            token : token,
            handleVendorNameDDL : handleVendorNameDDL,
            APIFlag : APIFlag
        }
        dispatch(VendorNameDDLAPI({ data }))
    },[WardName?.ID])

    const { WardDDLData } = useSelector(state => state.VendorNameDDLData)

    const handleVendorNameDDL = (WardDDLData) => {
        console.log('WardDDLData', WardDDLData)
        if (WardDDLData && WardDDLData.table && WardDDLData.table.length > 0) {
            let list = WardDDLData.table.map((item, index) => ({
                value: item.m_Ward_Wise_VendorID,
                label: item.vendorName,
            }))
            setVendorName({
                DDL: list,
                // ID: list[0]?.value ? list[0].value : 0,
                // Label: list[0]?.label ? list[0].label : 'Select...'
                ID: 0,
                Label: "Select...",
            })
        }
        else {
            setVendorName({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">

            <label className="d-block" htmlFor="NameofDepartment"><b>Vendor Name <AstricSign /></b></label>

            <Select
                isClearable={true}
                isSearchable
                maxMenuHeight={115}
                value={{ value: VendorName.ID, label: VendorName.Label }}
                onChange={(e) => {
                    e ?
                        setVendorName({ ...VendorName, ID: e.value, Label: e.label })
                        :
                        setVendorName({ ...VendorName, ID: 0, Label: "Select..." })
                }}
                options={VendorName.DDL}
            />
        </div>
    )
}